import { ImageAsset } from '../images/image-asset-model';
import { CategoryItem} from './category-item.model';
import { MembershipType } from './membership-type-item.model';

export class Organization
{
    Id: number;
    IsDocumentCenterEnabled = false;
    Name: string;
    Logo: ImageAsset;
    Photo: ImageAsset;
    WelcomeImage: ImageAsset;
    FeatureJson: string;
    CategoryItems: CategoryItem[] = [];
    MembershipTypes: MembershipType[];
    Locations: Location[];

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Handle any custom mappings here
            if (json.CategoryItems) this.CategoryItems = json.CategoryItems.map(j => new CategoryItem(j));
            if (json.MembershipTypes) this.MembershipTypes = json.MembershipTypes.map(j => new MembershipType(j));
            if (json.Logo) this.Logo = new ImageAsset(json.Logo);
        }
    }
}
